/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Button,
  InputNumber,
  Tooltip,
  InputNumberProps,
} from 'antd';
import { Formik, FormikHelpers } from 'formik';
import React, { memo, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Dictionaries } from '../../interfaces';
import { GeneralApi, ValuationApi } from '../../apis';
import * as Yup from 'yup';
import { UploadImage } from '../upload';

export const formSchema = (values: any) =>
  Yup.object().shape({
    fullName: Yup.string().required('Овог нэр заавал оруулах'),
    registerNo: Yup.string().required('Регистрийн дугаар заавал оруулах'),
    valuateType: Yup.mixed<'CUSTOM' | 'SYSTEM'>()
      .oneOf(['CUSTOM', 'SYSTEM'])
      .required('Заавал сонгоно уу'),

    odo: Yup.number().min(0, '0-с их байх ёстой').required('Заавал оруулах'),

    carBrandId: Yup.string().required('Заавал сонгоно уу'),
    carModelId: Yup.string().required('Заавал сонгоно уу'),

    engineCapacity: Yup.number().min(0, '0-с их байх ёстой').required('Заавал оруулах'),

    transmission: Yup.mixed<'AUTO' | 'MANUAL'>()
      .oneOf(['AUTO', 'MANUAL'])
      .required('Заавал сонгоно уу'),

    condition: Yup.mixed().required('Заавал сонгоно уу'),

    steering: Yup.mixed<'LEFT' | 'RIGHT'>().oneOf(['LEFT', 'RIGHT']).required('Заавал сонгоно уу'),

    engineType: Yup.mixed<'HYBRID' | 'PETROL' | 'DIESEL' | 'ELECTRIC'>().required(
      'Заавал сонгоно уу'
    ),

    drivetrain: Yup.mixed<'FWD' | 'RWD' | 'AWD' | '4WD'>()
      .oneOf(['FWD', 'RWD', 'AWD', '4WD'])
      .required('Заавал сонгоно уу'),

    exteriorColor: Yup.string().required('Заавал сонгоно уу'),
    interiorColor: Yup.string().required('Заавал сонгоно уу'),

    manufacturedYear: Yup.number()
      .max(new Date().getFullYear(), 'Ирээдүйн он')
      .required('Заавал оруулах'),

    importedYear: Yup.number()
      .max(new Date().getFullYear(), 'Ирээдүйн он')
      .required('Заавал оруулах')
      .test('is-greater', 'Импортолсон он нь үйлдвэрлэсэн оноос их байх ёстой', function (value) {
        const { manufacturedYear } = this.parent;
        if (!value || !manufacturedYear) return true;
        return value > manufacturedYear;
      }),

    price: Yup.number().min(0, '0 -с их байх шаардаглгатай').required('Заавал оруулах'),
  });

type FormDataType = {
  valuateType: 'CUSTOM' | 'SYSTEM' | undefined;
  odo: number | undefined;
  carBrandId: string | undefined;
  carModelId: string | undefined;
  engineCapacity: number | undefined;
  transmission: 'AUTO' | 'MANUAL' | undefined;
  condition: 'UNLICENSED' | 'USED' | 'NEW' | undefined;
  steering: 'LEFT' | 'RIGHT' | undefined;
  engineType: 'HYBRID' | 'PETROL' | 'DIESEL' | 'ELECTRIC' | undefined;
  drivetrain: 'FWD' | 'RWD' | 'AWD' | '4WD' | undefined;
  exteriorColor: string | undefined;
  interiorColor: string | undefined;
  manufacturedYear: number | undefined;
  importedYear: number | undefined;

  registerNo: string | undefined;
  fullName: string | undefined;

  price: number | undefined;
  vin: string | undefined;
  plateNumber: string | undefined;
};

type Props = {
  setAction: React.Dispatch<
    React.SetStateAction<{
      loading: boolean;
      payload: undefined;
    }>
  >;
};

const CalcForm = memo(({ setAction }: Props) => {
  const [general, setGeneral] = useState<Dictionaries>();
  const loadData = useCallback(async () => {
    const res = await GeneralApi.init();
    setGeneral(res);
  }, []);

  const initialValues: FormDataType = {
    valuateType: 'CUSTOM',
    registerNo: 'СЧ98122911',
    fullName: 'Соронзонболд',
    odo: 0,
    carBrandId: '66340c0a-824b-43b8-9c7c-baf41c95beb8',
    carModelId: '49a94875-700f-424d-8f2c-7f9529afbac9',
    engineCapacity: 1.8,
    transmission: 'AUTO',
    condition: 'UNLICENSED',
    steering: 'RIGHT',
    engineType: 'HYBRID',
    drivetrain: 'FWD',
    exteriorColor: 'BLACK',
    interiorColor: 'BLACK',
    manufacturedYear: 2013,
    importedYear: 2022,
    price: 17000000,
    plateNumber: '5929УНС',
    vin: undefined,

    // odo: undefined,
    // carBrandId: undefined,
    // carModelId: undefined,
    // engineCapacity: undefined,
    // transmission: undefined,
    // condition: undefined,
    // steering: undefined,
    // engineType: undefined,
    // drivetrain: undefined,
    // exteriorColor: undefined,
    // interiorColor: undefined,
    // manufacturedYear: undefined,
    // importedYear: undefined,
    // registerNo: undefined,
    // fullName: undefined,
  };

  const getOption = useCallback((value?: { code?: string; name: string; id: string }[] | any) => {
    if (!value) {
      return [];
    }

    return value.map((item: any) => ({
      label: item.name,
      value: item.code ?? item.id,
    }));
  }, []);

  const onSubmit = useCallback(
    async (values: FormDataType) => {
      setAction({
        loading: true,
        payload: undefined,
      });

      try {
        console.log('on submit :', values);
        const res = await ValuationApi.valuate(values);

        console.log('res :', res);

        setAction({
          loading: false,
          payload: res,
        });
      } catch {
        setAction({
          loading: false,
          payload: undefined,
        });
      }
    },
    [setAction]
  );

  const formatter: InputNumberProps<number>['formatter'] = (value: any) => {
    const [start, end] = `${value}`.split('.') || [];
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `₮ ${end ? `${v}.${end}` : `${v}`}`;
  };

  const parseNumber = (value?: string) => {
    if (!value) return 0;
    const cleaned = value.replace(/[^\d.-]/g, ''); // кома, ₮, зай г.м. арилгана
    const n = parseFloat(cleaned);
    return Number.isNaN(n) ? 0 : n;
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  // if (!general) return <></>;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={formSchema}
      onSubmit={(values: FormDataType, actions: FormikHelpers<FormDataType>) => onSubmit(values)}
    >
      {({ values, setFieldValue, handleSubmit, errors, touched }) => {
        return (
          <Container>
            <Form
              layout="vertical"
              className="form sm:w-full md:w-full lg:w-[600px] xl:w-[600px] 2xl-[800px] w-[600px]"
              onFinish={handleSubmit}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Овог, нэр"
                    validateStatus={errors.fullName && touched.fullName ? 'error' : ''}
                    help={errors.fullName && touched.fullName ? errors.fullName : ''}
                  >
                    <Input
                      name="fullName"
                      status={errors.fullName && touched.fullName ? 'error' : ''}
                      value={values.fullName}
                      onChange={(e) => setFieldValue('fullName', e.target.value)}
                      placeholder="Зээл хүсэгчийн овог, нэр"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Регистрийн дугаар"
                    validateStatus={errors.registerNo && touched.registerNo ? 'error' : ''}
                    help={errors.registerNo && touched.registerNo ? errors.registerNo : ''}
                  >
                    <Input
                      name="registerNo"
                      value={(values as any).registerNo}
                      onChange={(e) => setFieldValue('registerNo', e.target.value)}
                      placeholder="Регистрийн дугаар"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Улсын дугаар"
                    validateStatus={errors.plateNumber && touched.plateNumber ? 'error' : ''}
                    help={errors.plateNumber && touched.plateNumber ? errors.plateNumber : ''}
                  >
                    <Input
                      name="plateNumber"
                      status={errors.plateNumber && touched.plateNumber ? 'error' : ''}
                      value={values.plateNumber}
                      onChange={(e) => setFieldValue('plateNumber', e.target.value)}
                      placeholder="Зээл хүсэгчийн овог, нэр"
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Арлын дугаар"
                    validateStatus={errors.vin && touched.vin ? 'error' : ''}
                    help={errors.vin && touched.vin ? errors.vin : ''}
                  >
                    <Input
                      name="vin"
                      value={(values as any).vin}
                      onChange={(e) => setFieldValue('vin', e.target.value)}
                      placeholder="Арлын дугаар"
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Брэнд"
                    validateStatus={errors.carBrandId && touched.carBrandId ? 'error' : ''}
                    help={errors.carBrandId && touched.carBrandId ? errors.carBrandId : ''}
                  >
                    <Select
                      placeholder="Брэнд сонгох"
                      options={getOption(general?.carBrands || [])}
                      value={values.carBrandId}
                      onChange={(val) => setFieldValue('carBrandId', val)}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? ('' as any)).toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Загвар"
                    validateStatus={errors.carModelId && touched.carModelId ? 'error' : ''}
                    help={errors.carModelId && touched.carModelId ? errors.carModelId : ''}
                  >
                    <Select
                      placeholder="Загвар"
                      options={getOption(general?.carModels)}
                      value={values.carModelId}
                      onChange={(val) => setFieldValue('carModelId', val)}
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? ('' as any)).toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Моторын хэмжээ"
                    validateStatus={errors.engineCapacity && touched.engineCapacity ? 'error' : ''}
                    help={
                      errors.engineCapacity && touched.engineCapacity ? errors.engineCapacity : ''
                    }
                  >
                    <Select
                      placeholder="Моторын хэмжээ"
                      options={getOption(general?.engineCapacities)}
                      value={values.engineCapacity}
                      onChange={(val) => setFieldValue('engineCapacity', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Хурдны хайрцаг"
                    validateStatus={errors.transmission && touched.transmission ? 'error' : ''}
                    help={errors.transmission && touched.transmission ? errors.transmission : ''}
                  >
                    <Select
                      placeholder="Хурдны хайрцаг"
                      options={getOption(general?.transmissionTypes)}
                      value={values.transmission}
                      onChange={(val) => setFieldValue('transmission', val)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Нөхцөл"
                    validateStatus={errors.condition && touched.condition ? 'error' : ''}
                    help={errors.condition && touched.condition ? errors.condition : ''}
                  >
                    <Select
                      placeholder="Нөхцөл"
                      options={getOption(general?.vehicleConditions)}
                      value={values.condition}
                      onChange={(val) => setFieldValue('condition', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Хүрд"
                    validateStatus={errors.steering && touched.steering ? 'error' : ''}
                    help={errors.steering && touched.steering ? errors.steering : ''}
                  >
                    <Select
                      placeholder="Хүрд"
                      options={getOption(general?.steeringTypes)}
                      value={values.steering}
                      onChange={(val) => setFieldValue('steering', val)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Хөдөлгүүр"
                    validateStatus={errors.engineType && touched.engineType ? 'error' : ''}
                    help={errors.engineType && touched.engineType ? errors.engineType : ''}
                  >
                    <Select
                      placeholder="Хөдөлгүүр"
                      options={getOption(general?.engineTypes)}
                      value={values.engineType}
                      onChange={(val) => setFieldValue('engineType', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Хөтлөгч"
                    validateStatus={errors.drivetrain && touched.drivetrain ? 'error' : ''}
                    help={errors.drivetrain && touched.drivetrain ? errors.drivetrain : ''}
                  >
                    <Select
                      placeholder="Хөтлөгч"
                      options={getOption(general?.drivetrain)}
                      value={values.drivetrain}
                      onChange={(val) => setFieldValue('drivetrain', val)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Гадна өнгө"
                    validateStatus={errors.exteriorColor && touched.exteriorColor ? 'error' : ''}
                    help={errors.exteriorColor && touched.exteriorColor ? errors.exteriorColor : ''}
                  >
                    <Select
                      placeholder="Өнгө"
                      options={getOption(general?.exteriorColors)}
                      value={values.exteriorColor}
                      onChange={(val) => setFieldValue('exteriorColor', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Дотор өнгө"
                    validateStatus={errors.interiorColor && touched.interiorColor ? 'error' : ''}
                    help={errors.interiorColor && touched.interiorColor ? errors.interiorColor : ''}
                  >
                    <Select
                      placeholder="Дотор өнгө"
                      options={getOption(general?.interiorColors)}
                      value={values.interiorColor}
                      onChange={(val) => setFieldValue('interiorColor', val)}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label="Үйлдвэрлэсэн он"
                    validateStatus={
                      errors.manufacturedYear && touched.manufacturedYear ? 'error' : ''
                    }
                    help={
                      errors.manufacturedYear && touched.manufacturedYear
                        ? errors.manufacturedYear
                        : ''
                    }
                  >
                    <Select
                      placeholder="Он сонгох"
                      options={general?.yearsFrom2000.map((e) => ({ label: e, value: e }))}
                      value={values.manufacturedYear}
                      onChange={(val) => setFieldValue('manufacturedYear', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Орж ирсэн он дээд"
                    validateStatus={errors.importedYear && touched.importedYear ? 'error' : ''}
                    help={errors.importedYear && touched.importedYear ? errors.importedYear : ''}
                  >
                    <Select
                      placeholder="Он сонгох"
                      options={general?.yearsFrom2000.map((e) => ({ label: e, value: e }))}
                      value={values.importedYear}
                      onChange={(val) => setFieldValue('importedYear', val)}
                    />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="Явсан км"
                    validateStatus={errors.odo && touched.odo ? 'error' : ''}
                    help={errors.odo && touched.odo ? errors.odo : ''}
                  >
                    <InputNumber
                      placeholder="Явсан км"
                      value={values.odo}
                      onChange={(val) => setFieldValue('odo', val)}
                      style={{ width: '100%' }}
                      suffix={<Tooltip title="Extra information">КМ</Tooltip>}
                    />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    label="Үнэ"
                    validateStatus={errors.price && touched.price ? 'error' : ''}
                    help={errors.price && touched.price ? errors.price : ''}
                  >
                    <InputNumber
                      placeholder="Үнэ"
                      value={values.price}
                      onChange={(val) => setFieldValue('price', val)}
                      style={{ width: '100%' }}
                      formatter={formatter}
                      parser={parseNumber}
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* <div className="flex flex-row gap-3 mb-3">
                <UploadImage callBack={(e) => console.log('e :', e)} />
                <UploadImage callBack={(e) => console.log('e :', e)} />
                <UploadImage callBack={(e) => console.log('e :', e)} />
                <UploadImage callBack={(e) => console.log('e :', e)} />
              </div> */}

              <Button className="primary-btn" type="primary" onClick={() => handleSubmit()}>
                Үнэлгээ хийх
              </Button>
            </Form>
          </Container>
        );
      }}
    </Formik>
  );
});

const Container = styled.div`
  border: solid 1px #ffefee;
  border-radius: 8px;
  padding: 16px;
  width: '100%';

  .form {
    /* width: 100%; */
  }
`;

CalcForm.displayName = 'CalcForm';

export { CalcForm };
